import React from 'react';
import 'react-id-swiper/src/styles/scss/swiper.scss';
import Swiper from 'react-id-swiper';
import helper from '../../../helper/dish-helper.js';
import Counter from '../../mui/counter.jsx';
import HttpsProtocolImage from '../../common/https-protocol-image';
import classnames from 'classnames';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../../intl/helper';
import dishMenuMessages from '../../../intl/messages/dish-menu';
import globalMessages from '../../../intl/messages/global';
import getBrandConfig from '../../../helper/configs/brand';

import './dish-detail-container.scss';
import './dish-desc-popup.scss';
import GuessYouLove from '../../common/guess-you-love.jsx';

const DishDescPopupModes = {
  DEFAULT: 1, // popup模式
  PAGE: 2, // 单独页面模式
};

module.exports = React.createClass({
  displayName: 'DishDescPopup',
  contextTypes: {
    brandType: React.PropTypes.string,
  },
  propTypes: {
    dishesDataDuplicate: React.PropTypes.array.isRequired,
    dish: React.PropTypes.object.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    menuDataStatus: React.PropTypes.bool,
    backWhenPropsBtnTap: React.PropTypes.bool,
    toggleDishDescPopup: React.PropTypes.func,
    onCloseBtnTap: React.PropTypes.func,
    showHandleInput: React.PropTypes.func,
    mode: React.PropTypes.number,
    recommendDishList: React.PropTypes.array,
    dishTypesData: React.PropTypes.array,
    urlType: React.PropTypes.string,
    theme: React.PropTypes.string,
  },
  componentDidMount() {
    window.swiper = Swiper;
  },
  onCloseBtnTap(event) {
    if (event) {
      event.preventDefault();
    }

    const { onCloseBtnTap } = this.props;
    if (onCloseBtnTap) {
      onCloseBtnTap();
      return;
    }

    window.history.back(-1);
    this.props.toggleDishDescPopup();
  },
  onBtnTap(newCount, increment) {
    const { dish, onOrderBtnTap, onPropsBtnTap, backWhenPropsBtnTap } = this.props;
    if (increment) {
      onOrderBtnTap(dish, increment);
    } else {
      if (backWhenPropsBtnTap !== false) {
        this.onCloseBtnTap();
      }

      onPropsBtnTap(dish, 'fromPopUp');
    }
  },
  getDishTitle(dish) {
    if (dish.sameDishIndexs) {
      /* /${dish.unitName} */
      return `${dish.name}${dish.unitName !== '份' ? '/' + dish.unitName : ''}`;
    }
    return helper.generateDishNameWithUnit(dish, 'dishMenu');
  },
  getSameRuleDishList(dish, dishesDataDuplicate) {
    const { sameDishIndexs } = dish;
    return sameDishIndexs ? sameDishIndexs.map(dishIndex => dishesDataDuplicate[dishIndex]) : null;
  },
  getDishMemberPrice(dish, dishesDataDuplicate) {
    const sameRuleDishList = this.getSameRuleDishList(dish, dishesDataDuplicate);
    return helper.getDishMemberPriceWithSameRuleDishes(dish, sameRuleDishList);
  },
  buildOrderBtn(dish, dishesDataDuplicate) {
    const dishOrder = (dishesDataDuplicate || []).filter(item => item.id === dish.id)[0];
    const sameRuleDishList = this.getSameRuleDishList(dish, dishesDataDuplicate);
    const { brandType } = this.context;

    if (helper.isSingleDishWithoutProps(dish) && !sameRuleDishList) {
      if (dish.clearStatus) {
        // 单菜品直接展示已售罄
        return (
          <i className="dish-item-soldout-text">
            <FormattedMessage {...dishMenuMessages.soldout} />
          </i>
        );
      }

      return <Counter count={dishOrder.order} onCountChange={this.onBtnTap} step={dish.stepNum} dishItem={dishOrder} soldoutClassName="dish-item-soldout" />;
    }

    const dishes = sameRuleDishList || (dishOrder ? [dishOrder] : []);
    const count = helper.getDishesCount(dishes);
    const title = Array.isArray(dish.groups)
      ? getBrandConfig(brandType, 'dish-menu.select-child-dish', formatMessage(dishMenuMessages.choseChildDish))
      : formatMessage(dishMenuMessages.choseSpecification);
    let countStyle;
    if (count < 10) {
      countStyle = { width: '16px' };
    } else if (count >= 10 && count <= 99) {
      countStyle = { width: '21px' };
    } else {
      countStyle = { width: '27px' };
    }
    return (
      <div className="counter">
        <button className="btn--ellips btn-choose-property" onTouchTap={this.onBtnTap}>
          {title}
          {count > 0 ? (
            <span className={classnames('dish-desc--counter counter-special', { 'counter-special--modify': count > 99 })} style={countStyle}>
              {count > 99 ? '99+' : count}
            </span>
          ) : (
            false
          )}
        </button>
      </div>
    );
  },
  buildDishSoldNum(dishData) {
    const soldNum = parseInt(dishData.soldNum, 10);

    if (!soldNum || soldNum === 0) {
      return false;
    }
    return (
      <span className="dish-sales-volume">
        <FormattedMessage {...dishMenuMessages.monthlySales} />
        {soldNum}
      </span>
    );
  },
  buildDishResidueNum(dishData) {
    const { urlType } = this.props;
    const enableSaleNum = (urlType === 'WM' ? dishData.residueTotalWechat : dishData.residueTotal) || 0;
    const showSaleNum = sessionStorage.getItem('showSaleNum') === 'true' || false; // 是否开启了商品余量展示开关
    const isShowRemainderTip = enableSaleNum <= 10 && enableSaleNum > 0 && showSaleNum;
    if (isShowRemainderTip) {
      return (
        <span className="dish-sales-residue">
          <FormattedMessage {...globalMessages.onlyLeft} /> {`${enableSaleNum} ${dishData.unitName}`}
        </span>
      );
    }
    return null;
  },
  buildMemberPriceElement(dish, dishesDataDuplicate, useMergedMinPrice) {
    const memberPrice = this.getDishMemberPrice(dish, dishesDataDuplicate);
    const { marketPrice } = dish;
    if (dish.isUserMember) {
      return (
        <p className="clearfix">
          <span className="dish-desc-price--bold price">
            {memberPrice}
            {useMergedMinPrice && (
              <small>
                <FormattedMessage {...dishMenuMessages.priceFrom} />
              </small>
            )}
          </span>
          <span className="price-badge-wrap">
            <span className="dish-desc-price--del price">
              {marketPrice}
              {useMergedMinPrice && (
                <small>
                  <FormattedMessage {...dishMenuMessages.priceFrom} />
                </small>
              )}
            </span>
            <span className="dish-desc-price-badge">
              {dish.discountLevel}
              <FormattedMessage {...dishMenuMessages.justForVIP} />
              {dish.discountType === 1 || dish.discountType === 3 ? (
                <FormattedMessage {...dishMenuMessages.discountLevel} values={{ discountLevel: dish.memberPrice }} />
              ) : (
                <FormattedMessage {...dishMenuMessages.price} />
              )}
            </span>
          </span>
        </p>
      );
    }

    return (
      <p className="clearfix">
        <span className="dish-desc-price--bold price">
          {marketPrice}
          {useMergedMinPrice && (
            <small>
              <FormattedMessage {...dishMenuMessages.priceFrom} />
            </small>
          )}
        </span>
        <span className="price-badge-wrap">
          <span className="dish-desc-price--border">
            <FormattedMessage {...dishMenuMessages.memberPrice} />
            <i className="price">{memberPrice}</i>
            {useMergedMinPrice && (
              <small>
                <FormattedMessage {...dishMenuMessages.priceFrom} />
              </small>
            )}
          </span>
        </span>
      </p>
    );
  },
  renderDishDesc(dish) {
    const richDesc = dish.richDesc || '';
    if (!richDesc) {
      return <p className="dish-desc-desc">{dish.dishDesc || <FormattedMessage {...dishMenuMessages.noDesc} />}</p>;
    }

    const escapeScript = html => {
      return html.replace(/<([^>]*)script([^>]*)>/g, ($0, $1, $2) => {
        return `&lt;${$1}script${$2}&gt;`;
      });
    };

    return <div className="dish-desc__rich-desc" dangerouslySetInnerHTML={{ __html: escapeScript(richDesc) }} />;
  },
  onTouchStart() {
    this.mySwiper.stopAutoplay();
  },
  onTouchEnd() {
    setTimeout(() => {
      this.mySwiper.startAutoplay();
    }, 10);
  },
  renderTopNavBtn() {
    const { mode } = this.props;

    if (mode === DishDescPopupModes.PAGE) {
      return (
        <div className="dish-detail-back" onTouchTap={event => this.onCloseBtnTap(event)}>
          <a className="btn-back">
            <FormattedMessage {...dishMenuMessages.goOnPick} />
          </a>
        </div>
      );
    }

    return (
      <div className="dish-detail-close" onTouchTap={event => this.onCloseBtnTap(event)}>
        <a className="btn-close" />
      </div>
    );
  },
  render() {
    const { dish, dishesDataDuplicate, recommendDishList = [], dishTypesData, menuDataStatus } = this.props;
    const { onOrderBtnTap, onPropsBtnTap } = this.props;
    const { mergedMinPrice, marketPrice, largeImgList } = dish;
    const orderBtn = this.buildOrderBtn(dish, dishesDataDuplicate);
    const useMergedMinPrice = mergedMinPrice !== undefined;
    const dishSoldNumElement = this.buildDishSoldNum(dish);
    const residueNum = this.buildDishResidueNum(dish);

    return (
      <div className={classnames('dish-detail-container', 'dish-desc-container')}>
        {this.renderTopNavBtn()}
        <div className="dish-detail-content dish-detail-content--white">
          <div className="dish-desc-content">
            <div className="dish-desc-image" style={{ background: largeImgList.length !== 0 && '#fff' }}>
              {largeImgList.length !== 0 ? (
                <Swiper
                  pagination={largeImgList.length > 1 && '.swiper-pagination'}
                  paginationClickable
                  autoplay={2500}
                  onTouchStart={this.onTouchStart}
                  onTouchEnd={this.onTouchEnd}
                  onInit={swiper => (this.mySwiper = swiper)}
                  loop={largeImgList.length > 1}
                >
                  {largeImgList.map((item, key) => {
                    return <HttpsProtocolImage src={item} alt={dish.name} key={key} />;
                  })}
                </Swiper>
              ) : (
                false
              )}
            </div>
            <div className="dish-desc-info">
              <h2 className="dish-desc-title">{this.getDishTitle(dish)}</h2>
              {dishSoldNumElement}
              {residueNum}
              <div className="dish-desc-price-container">
                {dish.isMember ? (
                  this.buildMemberPriceElement(dish, dishesDataDuplicate, useMergedMinPrice)
                ) : (
                  <span className="dish-desc-price--bold price">
                    {parseFloat(useMergedMinPrice ? mergedMinPrice : marketPrice, 10)}
                    {useMergedMinPrice && (
                      <small>
                        <FormattedMessage {...dishMenuMessages.priceFrom} />
                      </small>
                    )}
                  </span>
                )}
                {orderBtn}
              </div>
              <h3 className="dish-desc-subtitle">
                <FormattedMessage {...dishMenuMessages.descSubtitle} />
              </h3>
              {this.renderDishDesc(dish)}
            </div>
            {recommendDishList && recommendDishList.length && menuDataStatus ? (
              <GuessYouLove
                recommendDishList={recommendDishList}
                dishesDataDuplicate={dishesDataDuplicate}
                dishTypesData={dishTypesData}
                onOrderBtnTap={onOrderBtnTap}
                onPropsBtnTap={onPropsBtnTap}
                recommendDishListOuterStyle={{ paddingTop: 10 }}
              />
            ) : (
              false
            )}
          </div>
        </div>
      </div>
    );
  },
});

module.exports.Modes = DishDescPopupModes;



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/dish-desc-popup.jsx